// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9c752669","977":"8e66ab13"}[chunkId] + ".chunk.js";
};